// extracted by mini-css-extract-plugin
module.exports = {"isNow":"license-table_isNow__21nLz","oldLastUsage":"license-table_oldLastUsage__2udx0"};